export var getBrowserLocale = function getBrowserLocale() {
  if (navigator.languages) {
    return navigator.languages[0];
  }
  return navigator.language;
};